import { Icon } from "@chakra-ui/icons";
import { Text } from "@chakra-ui/react";
import {
  MdCall,
  MdVideocam,
  MdCallReceived,
  MdOutlineCallMade,
  MdCallMissed,
} from "react-icons/md";

export const FormatCallDuration = (callData, currentUser) => {
  if (callData.endedAt && callData.answeredAt) {
    const totalSeconds = Math.floor(
      (new Date(callData.endedAt) - new Date(callData.answeredAt)) / 1000
    );

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    let formattedDuration = "";

    if (hours > 0) {
      formattedDuration += `${hours} hr `;
    }

    // Show minutes if there are any, or if hours are present (for consistency)
    if (minutes > 0 || hours > 0) {
      formattedDuration += `${minutes} min `;
    }

    formattedDuration += `${seconds} sec`;
    return (
      <Text fontSize="xs" color="gray.600">
        {formattedDuration.trim()}
      </Text>
    );
  } else {
    if (callData.currentStatus?.status === "missed") {
      if (callData.createdBy?._id === currentUser.id) {
        return <Text fontSize="xs">Not answered</Text>;
      } else {
        return (
          <Text fontSize="xs" color="red">
            Missed
          </Text>
        );
      }
    } else if (callData.currentStatus?.status === "initiated") {
      if (callData.createdBy?._id === currentUser.id) {
        return (
          <Text fontSize="xs" color="gray.600">
            Not reachable
          </Text>
        );
      } else {
        return (
          <Text fontSize="xs" color="red">
            You were not reachable
          </Text>
        );
      }
    } else if (callData.currentStatus?.status === "declined") {
      if (callData.createdBy?._id === currentUser.id) {
        return <Text fontSize="xs">Declined</Text>;
      } else {
        return (
          <Text fontSize="xs" color="gray.600">
            You declined
          </Text>
        );
      }
    } else {
      return (
        <Text fontSize="xs" color="gray.600">
          0 sec
        </Text>
      );
    }
  }
};

// to format seconds into MM:SS
export const formatTimeSecondsToHHMMSS = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
    .toString()
    .padStart(2, "0")}`;
};

export const getCallDirectionIcons = (pCallData, currentUser) => {
  if (pCallData.currentStatus?.status === "missed") {
    if (pCallData.createdBy?._id === currentUser.id) {
      return <MdOutlineCallMade color="blue" />;
    } else {
      return <MdCallMissed color="red" />;
    }
  } else {
    return pCallData.createdBy?._id === currentUser?.id ? (
      <MdOutlineCallMade color="blue" />
    ) : (
      <MdCallReceived color="green" />
    );
  }
};

export const getCallTypeIcons = (pCallType) => {
  return pCallType === "Video" ? (
    <Icon as={MdVideocam} boxSize={4} />
  ) : (
    <Icon as={MdCall} boxSize={4} />
  );
};

export const getCallReceiverName = (pCallChatData, currentUser) => {
  return pCallChatData.isGroup
    ? pCallChatData.chatName
    : pCallChatData.members[0]?._id === currentUser?.id
    ? pCallChatData.members[1].name
    : pCallChatData.members[0].name;
};
